import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import MainNavigation from "components/navigation/MainNavigation";
import styled from "styled-components";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuthCurrent } from "hooks/auth/auth_current";

export default function EditView() {
  const authCurrent = useAuthCurrent();
  const [showContent, setShowContent] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (authCurrent) {
      if (authCurrent.uId !== "") {
        setShowContent(true);
      } else {
        setShowContent(false);
        navigate("/login");
      }
    } else {
      setShowContent(false);
    }
  }, [authCurrent]);

  return (
    (showContent && (
      <div className="sakusas-main">
        <MainNavigation />
        <Toaster />
        <Div>
          <Outlet />
        </Div>
      </div>
    )) ||
    null
  );
}
const Div = styled.div`
  display: flex;
  margin-left: 5%;
  margin-top: 4rem;
  margin-bottom: 1rem;
  width: 75%;
  flex-direction: column;
  color: #764141;
  overflow: auto;
`;
